<template>
  <div class="social-wrap" :class="{ 'no-cursor': bindAccountNum === 1 && isBind }" @click="handleBind">
    <div class="google-btn">
      <div ref="googleBtn"></div>
    </div>
    <div class="wrap" :class="{ unbind: !isBind }">
      <div class="logo-wrap">
        <span class="logo google"></span>
        <span class="name">Google</span>
      </div>
      <div class="account-name" :class="{ 'no-arr': bindAccountNum === 1 && isBind }">
        <template v-if="isBind">{{ isBind }}</template>
        <template v-else>{{ $t('web_unbind') }}</template>
      </div>
    </div>
  </div>
</template>

<script>
import { bindAccount, unbindAccount } from '../utils/Qtbridge'
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  name: 'AccountGoogle',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {}
  },
  created () {
    if (!this.isBind) {
      this.initGoogle()
    }
  },
  mounted () {
    if (!this.isBind) {
      this.renderBtn()
    }
  },
  computed: {
    ...mapGetters(['bindAccountNum']),
    ...mapState({
      bindInfo: state => state.bindInfo.google,
    }),
    isBind () {
      const name = this.bindInfo.name || this.bindInfo.email || ''
      const arr = name.split('@')
      if (arr.length === 2) {
        return arr[0].substr(0,3)+'****'+arr[0].substr(-2) + (arr[1] ? `@${arr[1]}` : '')
      } else {
        return name
      }
    }
  },
  methods: {
    ...mapMutations({
      setBindInfoItem: 'setBindInfoItem'
    }),
    renderBtn () {
      window.google.accounts.id.renderButton(
        this.$refs.googleBtn, // Ensure the element exist and it is a div to display correcctly
        { shape: 'circle', width: '380' }  // Customization attributes
      )
    },
    initGoogle () {
      const gid = JSON.parse(window.localStorage.getItem('sdkParams') || '{}').gid
      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_ID || this.$ENUM.GOOGLE_ACCOUNT_MAP[gid], // Replace with your Google Client ID
        context: 'login',
        ux_mode: 'popup',
        auto_prompt: false,
        callback: this.handleCredentialResponse // We choose to handle the callback in client side, so we include a reference to a function that will handle the response
      })
    },
    handleCredentialResponse (response) {
      this.userInfo = this.getGoogleUserInfo(response.credential)

      bindAccount(this.userInfo)
        .then(res => {
          if (res.code !== 0) this.$msg.success(res.msg || this.$t('web_bind_fail'))
          this.setBindInfoItem({
            key: 'google',
            value: {
              email: this.userInfo.name
            }
          })
          this.$msg.success(this.$t('web_bind_ok'))
        })
        .catch(err => {
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
        })
    },
    getGoogleUserInfo (token) {
      var base64Str = token.split('.')[1];
      var base64 = base64Str.replace(/-/g,'+').replace(/_/g,'/')
      const data = JSON.parse(window.atob(base64))
      const params = {
        id: data.sub,
        name: data.email,
        token: token,
        type: 'google',
        expire: (data.exp || 0) - (data.iat || 0)
      }

      window.google.accounts.id.revoke(params.id)
      return params
    },
    handleBind () {
      if (!this.isBind) return
      if (this.bindAccountNum <= 1) return
      // 去掉解绑
      this.$dialog(
        {
          type: 'google',
          title: this.$t('web_tips_title'),
          text: this.$t('web_unbind_tips', { 0: 'Google' }),
          confirmTxt: this.$t('test_confirm'),
          cancelTxt: this.$t('test_cancel')
        },
        this.unbind
      )
    },
    unbind (response) {
      const params = this.getGoogleUserInfo(response.credential)

      this.$Spin.show()
      unbindAccount(params)
        .then(res => {
          if (res.code !== 0) this.$msg.success(res.msg)
          this.setBindInfoItem({
            key: 'google',
            value: {
              name: '',
              email: ''
            }
          })
          window.unbindClose()
          this.$msg.success(this.$t('web_tips_unbind'))
          this.$Spin.hide()
          this.initGoogle()
          this.renderBtn()
        })
        .catch(err => {
          this.$msg.success(this.$t(`KGSDK_${err.code}`))
          this.$Spin.hide()
        })
    }
  }
}
</script>

<style lang='less' scoped >
@import url('@/assets/styles/account.less');
</style>
